import { call, fork, put, takeEvery } from 'redux-saga/effects';
import NoticeStoreApi from '../../../../lib/api/notice/store/NoticeStoreApi';
import { reDirectPage, setMultipartForm, setRequestForm, setResponseListForm } from '../../../../lib/common.js';
import toastMsg from '../../../../lib/toastMsg';
import { excelDownLoad } from '../../../../lib/common';
import noticeStoreActions from './actions';
import noticeStoreToastMsg from '../../../../constants/service/toastMsg/noticeStoreToastMsg';
import { NOTICE_STORE_LIST_URL_PATH } from '../../../../constants/service/common/urlConstants';

function* fetchList() {
  /**
   *  [상점 공지사항 리스트] 상점 공지사항 리스트 가져오기
   */
  yield takeEvery(noticeStoreActions.GET_NOTICE_STORE_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeStoreApi.getNoticeStoreList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeStoreToastMsg.GET_NOTICE_STORE_LIST_REQUEST_SUCCESS);
        const data = {
          noticeStoreList: setResponseListForm(result.data.noticeStoreList, result.data.totalCnt, payload),
        };
        yield put({ type: noticeStoreActions.GET_NOTICE_STORE_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(noticeStoreToastMsg.GET_NOTICE_STORE_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상점 공지사항 리스트] 상점 공지사항 리스트 엑셀 다운로드 하기
   */
  yield takeEvery(noticeStoreActions.GET_NOTICE_STORE_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeStoreApi.getNoticeStoreExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeStoreToastMsg.GET_NOTICE_STORE_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('상점 공지사항 리스트', result.data.storeNoticeExcelSheet);
      }
    } catch (error) {
      toastMsg.error(noticeStoreToastMsg.GET_NOTICE_STORE_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상점 공지사항 리스트] 선택된 상점 공지사항 삭제하기
   */
  yield takeEvery(noticeStoreActions.DELETE_NOTICE_STORE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeStoreApi.deleteNoticeStore, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeStoreToastMsg.DELETE_NOTICE_STORE_REQUEST_SUCCESS);
        yield put({ type: noticeStoreActions.DELETE_NOTICE_STORE_SUCCESS, payload: payload });
      }
    } catch (error) {
      toastMsg.error(noticeStoreToastMsg.DELETE_NOTICE_STORE_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상점 공지사항 등록] 상점 공지사항 등록시 필요한 정보 가져오기
   */
  yield takeEvery(noticeStoreActions.PREPARE_ADD_NOTICE_STORE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeStoreApi.prepareAddNoticeStore, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeStoreToastMsg.PREPARE_ADD_NOTICE_STORE_REQUEST_SUCCESS);
        yield put({ type: noticeStoreActions.PREPARE_ADD_NOTICE_STORE_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(noticeStoreToastMsg.PREPARE_ADD_NOTICE_STORE_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상점 공지사항 등록] 상점 공지사항 추가하기
   */
  yield takeEvery(noticeStoreActions.ADD_NOTICE_STORE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeStoreApi.addNoticeStore, setMultipartForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeStoreToastMsg.ADD_NOTICE_STORE_REQUEST_SUCCESS);
        reDirectPage({ path: NOTICE_STORE_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(noticeStoreToastMsg.ADD_NOTICE_STORE_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상점 공지사항 편집] 상점 공지사항 요청하기
   */
  yield takeEvery(noticeStoreActions.GET_NOTICE_STORE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeStoreApi.getNoticeStore, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeStoreToastMsg.GET_NOTICE_STORE_REQUEST_SUCCESS);
        yield put({ type: noticeStoreActions.GET_NOTICE_STORE_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(noticeStoreToastMsg.GET_NOTICE_STORE_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상점 공지사항 등록] 상점 공지사항 편집하기
   */
  yield takeEvery(noticeStoreActions.EDIT_NOTICE_STORE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeStoreApi.editNoticeStore, setMultipartForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeStoreToastMsg.EDIT_NOTICE_STORE_REQUEST_SUCCESS);
        reDirectPage({ path: NOTICE_STORE_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(noticeStoreToastMsg.EDIT_NOTICE_STORE_REQUEST_ERROR, error);
    }
  });
}

export default function* noticeSaga() {
  yield fork(fetchList);
}
